const menuList = [
  {
    id: 1,
    name: "Burger",
    title: true,
    price: 0,
  },
  {
    id: 2,
    name: "Classic Veg Burger",
    title: false,
    price: 29,
  },
  {
    id: 3,
    name: "Classic Panner Burger",
    title: false,
    price: 49,
  },
  {
    id: 4,
    name: "Loaded Cheese Burger",
    title: false,
    price: 39,
  },
  {
    id: 5,
    name: "Double Patty Veg Burger",
    title: false,
    price: 59,
  },
  {
    id: 6,
    name: "Pluto Special Veg Burger",
    title: false,
    price: 69,
  },
  {
    id: 7,
    name: "French Fries",
    title: true,
    price: 0,
  },
  {
    id: 8,
    name: "Classic Frech Fries",
    title: false,
    price: 29,
  },
  {
    id: 9,
    name: "Peri-Peri French Fries",
    title: false,
    price: 35,
  },
  {
    id: 10,
    name: "Cheese French Fries",
    title: false,
    price: 35,
  },
  {
    id: 11,
    name: " Masala French Fries",
    title: false,
    price: 35,
  },
  {
    id: 12,
    name: "Sandwich",
    title: true,
    price: 0,
  },
  {
    id: 13,
    name: "Classic Veg Sandwich",
    title: false,
    price: 29,
  },
  {
    id: 14,
    name: "Creamy Malai Sandwich",
    title: false,
    price: 39,
  },
  {
    id: 15,
    name: "Masala Sandwich",
    title: false,
    price: 39,
  },
  {
    id: 16,
    name: " Classic Veg with loaded Cheese Sandwich",
    title: false,
    price: 39,
  },
  {
    id: 17,
    name: "Classic Banana Sandwich",
    title: false,
    price: 29,
  },
  {
    id: 18,
    name: " Pluto Special Sandwich",
    title: false,
    price: 69,
  },
  {
    id: 19,
    name: "Maggie",
    title: true,
    price: 0,
  },
  {
    id: 20,
    name: " Classic Veg Maggie",
    title: false,
    price: 29,
  },
  { id: 21, name: "Veg Maggie with Cheese blast", title: false, price: 39 },
  {
    id: 22,
    name: " Spicy Masala Maggie",
    title: false,
    price: 35,
  },

  {
    id: 23,
    name: "  Plain Butter Maggie",
    title: false,
    price: 25,
  },
  {
    id: 24,
    name: "Hot Schezwan Maggie",
    title: false,
    price: 29,
  },
  {
    id: 25,
    name: " Soupy Maggie",
    title: false,
    price: 25,
  },
  {
    id: 26,
    name: " Cheese Corn Maggie",
    title: false,
    price: 39,
  },

  {
    id: 27,
    name: "Potato Twister",
    title: true,
    price: 0,
  },

  {
    id: 28,
    name: "Masala Twister",
    title: false,
    price: 29,
  },
  {
    id: 29,
    name: " Peri-Peri Cheese Twister",
    title: false,
    price: 35,
  },
  {
    id: 30,
    name: "Hot Schezwan Twister",
    title: false,
    price: 39,
  },
  {
    id: 31,
    name: " Pluto Potato Twister",
    title: false,
    price: 49,
  },
  {
    id: 32,
    name: " Cold Coffee",
    title: true,
    price: 0,
  },
  {
    id: 33,
    name: "Pluto Iced Coffee",
    title: false,
    price: 29,
  },
  {
    id: 34,
    name: " Frappuccino",
    title: false,
    price: 39,
  },
  {
    id: 35,
    name: " Iced Mocha",
    title: false,
    price: 39,
  },
  {
    id: 36,
    name: "Classic Cold Coffee",
    title: false,
    price: 29,
  },
  {
    id: 37,
    name: " Pluto Freek shake Coffee",
    title: false,
    price: 39,
  },

  {
    id: 38,
    name: "Hot Beverages",
    title: true,
    price: 0,
  },
  {
    id: 39,
    name: "Hot Coffee",
    title: false,
    price: 9,
  },
  {
    id: 40,
    name: "Filter Coffee",
    title: false,
    price: 9,
  },
  {
    id: 41,
    name: "Masala Ginger Tea",
    title: false,
    price: 9,
  },
  {
    id: 42,
    name: "Combo",
    title: true,
    price: 0,
  },
  {
    id: 43,
    name: "Classic Veg Burger + French Fries + Classic Cold Coffee",
    title: false,
    price: 69,
  },
  {
    id: 44,
    name: "Classic Veg Burger + French Fries + Coke",
    title: false,
    price: 69,
  },
  {
    id: 45,
    name: " Classic Veg Maggie + Classic Cold Coffee",
    title: false,
    price: 49,
  },
  {
    id: 46,
    name: " Maggie + Coke + French Fries",
    title: false,
    price: 69,
  },
  {
    id: 47,
    name: " Masala Twister + Classic Cold coffee + Classic Veg Maggie",
    title: false,
    price: 69,
  },
  {
    id: 48,
    name: "  Masala Twister + Coke + Maggie",
    title: false,
    price: 69,
  },
  {
    id: 49,
    name: " Classic Veg Sandwitch + French Fries + Coke",
    title: false,
    price: 69,
  },
  {
    id: 50,
    name: " Classic Veg Sandwitch + French Fries + Cold coffee",
    title: false,
    price: 69,
  },
  {
    id: 51,
    name: "  Classic Veg Sandwitch + Tea/Coffee",
    title: false,
    price: 39,
  },
];

export default menuList;
